import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import FintooBackButton from "../../HTML/FintooBackButton";
import commonEncode from "../../../commonEncode";
import { DATA_BELONGS_TO } from "../../../constants";
import axios from "axios";
import moment from "moment";
import { fetchEncryptData, apiCall, getUserId, getItemLocal } from "../../../common_utilities";
import { useNavigate } from "react-router-dom";
import { fetchUserProfileDetails, sendMail } from "../../../FrappeIntegration-Services/services/user-management-api/userApiService";
import { SendSMs } from "../../../FrappeIntegration-Services/services/financial-planning-api/ndaflow";
import { addNomineeDetails } from "../../../FrappeIntegration-Services/services/investment-api/investmentService";

const TwoFactorOtpModal = (props) => {
  const user_data = JSON.parse(localStorage.getItem("user_data"));

  console.log("user_data", user_data)
  const timer = useRef({ obj: null, counter: 120, default: 120 });
  const otpRef = useRef(null);
  const [count, setCount] = useState(120);
  const [useremail, setuseremail] = useState("");
  const [usermobile, setusermobile] = useState("");
  const [generateotp, setGeneratedSmsOTP] = useState("");
  const [generatedemailotp, setGeneratedEmailOTP] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [validOtp, setValidOtp] = useState(true);
  const [nomineeflag, setnomineeflag] = useState("");
  const [username, SetName] = useState("");

  const navigate = useNavigate();

  const generateOTP = () => {
    const otp = Math.floor(Math.random() * 90000) + 10000;
    otpRef.current = otp;
    return otp;
  };

  const handleOtpChange = (e) => {
    if (e.target.value.length > 5) {
      setOtpInput("");
      setValidOtp(false);
    } else {
      setOtpInput(e.target.value);
      setValidOtp(true);
    }
  };

  const submitOtp = () => {
    if (otpRef.current !== Number(otpInput)) {
      setValidOtp(false);
    } else {
      setValidOtp(true);
      // if (nomineeflag == null || nomineeflag === "") {
      //   // updatenominee();
      // }
      props.onSubmit();
    }
  };

  // const updatenominee = async () => {
  //   try {
  //     await apiCall(DMF_UPDATENOMINEE_API_URL, {
  //       user_id: getUserId(),
  //       data_belongs_to: DATA_BELONGS_TO,
  //       is_authenticated: "1",
  //     });
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  const updatenominee = async () => {
    try {

      const payload = {
        user_id: getUserId(),
        "data_belongs_to": DATA_BELONGS_TO,
      }

      await addNomineeDetails(payload)
      // var res = await apiCall(DMF_UPDATENOMINEE_API_URL, {
      //   user_id: getUserId(),
      //   data_belongs_to: DATA_BELONGS_TO,
      //   is_authenticated: "1",
      // });
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSms = async () => {
    const otp = otpRef.current || generateOTP();
    setGeneratedSmsOTP(otp);

    const msg = `Greetings from Fintoo! Your OTP verification code is ${otp}`;
    const whatsapptext = `Greetings from Fintoo! Your OTP verification code is : ${otp}`;

    try {
      const urlsms = {
        msg,
        mobile: usermobile,
        whatsapptext,
        sms_api_id: "fintoo_otp",
      };
      const res = await SendSMs(urlsms);
      commonEncode.decrypt(res.data);
    } catch (err) {
      console.error("SMS sending failed:", err);
    }
  };

  const fetchMail = async () => {
    const otp = otpRef.current || generateOTP();
    setGeneratedEmailOTP(otp);

    try {
      const urlmail = {
        userdata: { to: useremail },
        subject: "Fintoo - Your one time password",
        template: "otp_message_template.html",
        contextvar: { otp, name: username },
      };
      const res = await sendMail(urlmail);
      commonEncode.decrypt(res.data);
    } catch (err) {
      console.error("Email sending failed:", err);
    }
  };

  // const onLoadInIt = async () => {
  //   try {
  //     const userid = getUserId();
  //     const response = await fetchUserProfileDetails(userid);
  //     const user_data = response?.data;

  //     if (response.status_code === "200") {
  //       SetName(user_data.user_name);
  //       setnomineeflag(user_data.is_authenticated);
  //       setuseremail(user_data.user_email);
  //       setusermobile(user_data.mobile);
  //     }
  //   } catch (e) {
  //     console.error("User profile fetch failed:", e);
  //   }
  // };

  // const onLoadInIt = () => {
  //   SetName(user_data.user_name)
  //   setnomineeflag(user_data.is_authenticated);
  //   setuseremail(user_data.user_email);
  //   setusermobile(user_data.mobile);
  // };

  const startTimer = () => {
    timer.current.obj = setInterval(() => {
      if (timer.current.counter > 0) {
        timer.current.counter = timer.current.counter - 1;
        setCount(timer.current.counter);
      } else {
        clearInterval(timer.current.obj);
        timer.current.counter = timer.current.default;
      }
    }, 1000);
  };
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user_data")) || {};
    if (userData) {
      SetName(userData.user_name || "");
      setnomineeflag(userData.is_authenticated || false);
      setuseremail(userData.user_email || "");
      setusermobile(userData.mobile || "");
    }
  }, []);
  
  useEffect(() => {
    if (useremail && usermobile) {
      // ✅ this runs only once because of ref guard
      if (!otpRef.current) {
        const otp = generateOTP();
        fetchMail();
        fetchSms();
        timer.current.counter = timer.current.default;
        setCount(timer.current.default);
        startTimer();
      }
    }
  }, [useremail, usermobile]);
  
  var props_data = props.value;

  return (
    <>
      <Modal.Header className="py-3">
        <FintooBackButton onClick={() => props.onBack()} />
        <div className="modal-title">Two Factor Authentication</div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="modal-whitepopup-box-item grey-color border-top-0 text-center">
            <p>Please enter OTP sent to</p>
            <p><strong>{useremail}</strong></p>
            <p><strong>{usermobile}</strong></p>
          </div>

          <div className="text-center p-4">
            <input
              type="text"
              maxLength={5}
              minLength={5}
              placeholder="Enter OTP here"
              className="bottom-border-input w-50 text-center grey-color"
              value={otpInput}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={handleOtpChange}
            />
          </div>

          <div className="text-center p-4 grey-color">
            {count === 0 ? (
              <p
                className="pointer blue-color"
                onClick={() => {
                  generateOTP();
                  fetchSms();
                  fetchMail();
                  setValidOtp(true);
                  timer.current.counter = timer.current.default;
                  setCount(timer.current.default);
                  startTimer();
                }}
              >
                Resend OTP
              </p>
            ) : (
              <p>
                Resend OTP in{" "}
                <strong>
                  {moment().startOf("day").seconds(count).format("mm:ss")}
                </strong>
              </p>
            )}
            {!validOtp && <p className="red-color">Invalid OTP</p>}
          </div>

          <div
            className="mt-3 switch-fund-btn mobile-bottom-button"
            onClick={submitOtp}
          >
            Submit
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default TwoFactorOtpModal;
